import ApiSets from '@/api/apiSets'
import Vue from 'vue'
import router from '../router'
import Set from '@/models/set'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
});

const state = {
  sets: []
}

const actions = {
  updateSets(context, data) {
    startLoading(context.dispatch, 'Guardando Jornadas...')
    ApiSets.update(data.sets, data.tournamentID, (response) => {
      endLoading(context.dispatch, 'Guardando Jornadas...')
        console.log(response)
    }, error => {
      console.log('Error', error)
      endLoading(context.dispatch, 'Guardando Jornadas...')
    })
  }
}

const mutations = {

}

const getters = {

}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/sets.js